import { PublicTeamFragment } from '../GraphQL/schema/types';
import config from '../config';
import { replaceHostnameInUrl } from '../widget/src/utils/replaceHostnameInUrl';

export const createBackendUrl = (
  path: string,
  params?: Record<string, string>,
  team?: PublicTeamFragment
): string => {
  let baseUrl = config.API_SERVER_URL;

  if (team?.domain && team.isDomainVerified) {
    baseUrl = replaceHostnameInUrl(baseUrl, team.domain);
  }

  const url = `${baseUrl}/${path}`;

  if (!params) return url;

  const query = new URLSearchParams(params);
  return `${url}?${query.toString()}`;
};
